import { useNavigate } from "react-router-dom";
import { ArrowRight, ArrowUpRight, Home, Users, FileText, Briefcase } from "lucide-react";
import { CATEGORIES } from "../data/services";
import { Eyebrow, Reveal } from "../lib/ui";

const ICONS = { home: Home, users: Users, file: FileText, briefcase: Briefcase };

const CategoryCard = ({ cat, index }) => {
  const navigate = useNavigate();
  const Icon = ICONS[cat.icon] || FileText;
  const featured = index === 0;

  return (
    <div
      role="link"
      tabIndex={0}
      data-testid={`area-card-${cat.slug}`}
      onClick={() => navigate(`/ydelser/${cat.slug}`)}
      onKeyDown={(e) => e.key === "Enter" && navigate(`/ydelser/${cat.slug}`)}
      className={`group flex h-full cursor-pointer flex-col p-7 transition-all duration-300 ${
        featured
          ? "rounded-3xl bg-brand-950 text-white hover:shadow-2xl hover:shadow-brand-950/30"
          : "rounded-3xl border border-slate-200 bg-white hover:-translate-y-1 hover:shadow-xl hover:shadow-slate-900/5"
      }`}
    >
      <div className="flex items-center justify-between">
        <span className={featured ? "text-white" : "text-brand-600"}>
          <Icon className="h-12 w-12" strokeWidth={1.3} />
        </span>
        {!featured && <ArrowUpRight className="h-4 w-4 text-slate-300 transition-all duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 group-hover:text-brand-600" />}
      </div>
      <h3 className={`mt-6 text-xl font-semibold tracking-tight ${featured ? "text-white" : "text-slate-900"}`}>{cat.title}</h3>
      <p className={`mt-2 flex-1 text-sm leading-relaxed ${featured ? "text-white/70" : "text-slate-600"}`}>{cat.short}</p>
      <p className={`mt-4 text-sm font-medium ${featured ? "text-white/50" : "text-slate-400"}`}>
        {cat.items.map((p) => p.title).join(" · ")}
      </p>
      <div className={`mt-6 ${featured ? "" : "border-t border-slate-100 pt-4"}`}>
        <span className={`inline-flex items-center gap-1.5 text-sm font-semibold ${featured ? "text-white" : "text-brand-600"}`}>
          Se ydelserne
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
        </span>
      </div>
    </div>
  );
};

export const PracticeAreas = () => {
  return (
    <section id="omraeder" className="scroll-mt-20 border-t border-slate-200 py-16 sm:py-24 lg:py-28">
      <div className="mx-auto max-w-[1440px] px-6 sm:px-8 lg:px-12">
        <Reveal>
          <Eyebrow>Ydelser</Eyebrow>
          <h2 className="mt-4 max-w-3xl text-4xl font-semibold tracking-[-0.02em] text-slate-900 sm:text-5xl">
            Hvad kan vi hjælpe dig med?
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-600 sm:text-lg">
            Vælg det område, din sag handler om — så møder vi dig der, hvor du er. Er du i
            tvivl, så fortæl blot kort om situationen.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CATEGORIES.map((cat, i) => (
            <Reveal key={cat.slug} delay={i * 0.06} className="h-full">
              <CategoryCard cat={cat} index={i} />
            </Reveal>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PracticeAreas;